export const possibleUserRole = {
	admin: "ADMIN",
};
